import { Switch } from '@rneui/base/dist/Switch/Switch';
import { withTheme } from '../config';
export { Switch };
export default withTheme(Switch, 'Switch');
